import type { Session } from "next-auth";
import { useSession } from "next-auth/react";

export type CurrentUser = Session["user"];

/***
 *  We are trying to update current user to just use
 *  next auth session, but we are keeping the old one
 *  for now, until we are sure that the new one is working
 *  This feature flag will be removed in NVS-6252
 **/
export const useCurrentUser = () => {
  const { data, status } = useSession();

  return {
    currentUser: data?.user ?? ({} as CurrentUser),
    isLoading: status === "loading",
    status,
  };
};
